// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_container__Wu32d {
    background-color: #FFFFFF;
    height: 100%;
    width: 100%;
    border-radius: 21px;
    box-shadow: 0 0 40px -24px #37477E99;
    font-family: Poppins, sans-serif;
    font-size: 14px;
}

.table_head__bJgzS {
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-bottom: 40px;
}

.table_searchbar__xrGSJ input {
    margin-top: 25px;
    width: 430px;
    background-color: #EAEAEC;
    border: #EDEDED 1px solid;
    height: 30px;
    font-size: 14px;
    line-height: 21px;
    font-weight: 500;
    color: #BBBEC2;
    padding-left: 30px;
    border-radius: 0 10px 10px 0;
    font-family: "Poppins", sans-serif;
}

.table_searchbar__xrGSJ input:focus {
    border: #dadada 1px solid;
    border-left: #EDEDED 1px solid;
    outline: none !important;
}

.table_table__NjLLw thead th {
    color: #999999;
    font-weight: 500;
    padding: 15px 20px;
    font-size: 14px;
    border-bottom: 1px solid #E1E1E1;
    text-align: left;
}

.table_table__NjLLw tbody tr {
    cursor: pointer;
}

.table_table__NjLLw tbody td {
    white-space: nowrap;
    height: 55px !important;
    width: 257px;
    text-align: left;
    border-bottom: 1px solid #E1E1E1;
    color: #16213B;
    padding: 0 20px;
    vertical-align: middle;
}

.table_table__NjLLw tr:hover td {
    background-color: rgba(243, 39, 53, 0.15) !important;
}

.table_customtd__-bqUN {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
}

.table_body__-P1jw {
    padding: 0 10px;
}

.table_addContainer__SpVE\\+ {
    border: #6A86C8 solid 1.5px;
    align-self: start;
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
    height: 60px;
    width: 120px;
    border-radius: 0 21px 0 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6A86C8;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/ajonjolib/table/table.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,oCAAoC;IACpC,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".container {\n    background-color: #FFFFFF;\n    height: 100%;\n    width: 100%;\n    border-radius: 21px;\n    box-shadow: 0 0 40px -24px #37477E99;\n    font-family: Poppins, sans-serif;\n    font-size: 14px;\n}\n\n.head {\n    display: flex;\n    justify-content: space-between;\n    align-items: start;\n    margin-bottom: 40px;\n}\n\n.searchbar input {\n    margin-top: 25px;\n    width: 430px;\n    background-color: #EAEAEC;\n    border: #EDEDED 1px solid;\n    height: 30px;\n    font-size: 14px;\n    line-height: 21px;\n    font-weight: 500;\n    color: #BBBEC2;\n    padding-left: 30px;\n    border-radius: 0 10px 10px 0;\n    font-family: \"Poppins\", sans-serif;\n}\n\n.searchbar input:focus {\n    border: #dadada 1px solid;\n    border-left: #EDEDED 1px solid;\n    outline: none !important;\n}\n\n.table thead th {\n    color: #999999;\n    font-weight: 500;\n    padding: 15px 20px;\n    font-size: 14px;\n    border-bottom: 1px solid #E1E1E1;\n    text-align: left;\n}\n\n.table tbody tr {\n    cursor: pointer;\n}\n\n.table tbody td {\n    white-space: nowrap;\n    height: 55px !important;\n    width: 257px;\n    text-align: left;\n    border-bottom: 1px solid #E1E1E1;\n    color: #16213B;\n    padding: 0 20px;\n    vertical-align: middle;\n}\n\n.table tr:hover td {\n    background-color: rgba(243, 39, 53, 0.15) !important;\n}\n\n.customtd {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    text-align: left;\n}\n\n.body {\n    padding: 0 10px;\n}\n\n.addContainer {\n    border: #6A86C8 solid 1.5px;\n    align-self: start;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 21px;\n    height: 60px;\n    width: 120px;\n    border-radius: 0 21px 0 21px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #6A86C8;\n    user-select: none;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `table_container__Wu32d`,
	"head": `table_head__bJgzS`,
	"searchbar": `table_searchbar__xrGSJ`,
	"table": `table_table__NjLLw`,
	"customtd": `table_customtd__-bqUN`,
	"body": `table_body__-P1jw`,
	"addContainer": `table_addContainer__SpVE+`
};
export default ___CSS_LOADER_EXPORT___;
